import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/** Redirect logged-in user from "/" to dashboard (admin) or portal (partner). */
export default function HomeRedirect() {
  const { user } = useAuth();
  if (user?.role === 'owner') return <Navigate to="/dashboard" replace />;
  if (user?.role === 'partner' && user.partnerId != null) return <Navigate to={`/portal/${user.partnerId}`} replace />;
  return <Navigate to="/login" replace />;
}
